import React from "react";
import { SectionHeader } from "../../../common/WorkspaceChrome";

export function ApprovalsTab({ approvalQueue, decideApproval }) {
  return (
    <section className="panel">
      <SectionHeader
        eyebrow="Approvals"
        title="Manager decisions waiting for action"
        text="Leave, attendance, client, finance, and work approvals can be handled from one queue."
      />
      <div className="approval-queue">
        {approvalQueue.map((row) => (
          <article key={`${row.title}-${row.owner}`}>
            <div>
              <strong>{row.title}</strong>
              <span>{row.owner} · {row.meta}</span>
            </div>
            <div className="approval-actions">
              <small>{row.status}</small>
              <button onClick={() => decideApproval(row.title, "Approved")} type="button">Approve</button>
              <button onClick={() => decideApproval(row.title, "Rejected")} type="button">Reject</button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
